import base from "./base";
import membar from "./member";
import search from "./search";
import monitoring from "./monitoring";
import excel from "./excel";
import trace from "./trace";
import statistics from "./statistics";
import keyword from "./keyword";
import ai from "./ai";
import searchRoom from "./searchRoom";
import xCharge from "./xCharge";
import report from "./report";

export default {
    base,
    membar,
    search,
    monitoring,
    excel,
    trace,
    statistics,
    keyword,
    ai,
    searchRoom,
    xCharge,
    report,
};
